export function extractIdFromIri(iri) {
  // Match the ID at the end of the IRI
  const match = iri.match(/\/([^/]+)$/);
  return match ? match[1] : null;
}
